import { useEffect, useState } from 'react';
import Course from 'src/model/Course';
import CourseRetriever from 'src/retriever/CourseRetriever';

export default function useGetCourse(
  setError: (isError: boolean) => void,
  courseId?: string,
): Course {
  const [courseState, setCourse] = useState({ courseId: 'temporary_id', image: '' } as Course);
  useEffect(() => {
    CourseRetriever.getCourse(courseId)
      .then((course) => {
        setCourse(course);
      })
      .catch(() => {
        setError(true);
      });
  }, []);

  return courseState;
}
